module.exports = {
	"data": {
		"markdownRemark": {
			"html": "<p>Before learning about how to write a todo client across the hypermedia API, let’s start by running the existing one.</p>\n<p>The live demo:</p>\n<ul>\n<li><a href=\"https://api.todo.semanticlink.io\">api.todo.semanticlink.io</a></li>\n<li>credentials (<code>test-1@semanticlink.io</code> with password <code>1234qwerZXCV</code>)</li>\n</ul>\n<p><img src=\"/frontend/vue-todo-app/todo-app.png\" alt=\"todo app\"></p>\n<h3>Run demo server and client</h3>\n<h4>Install dependencies</h4>\n<Instruction>\n<p>Clone the git repo and install dependencies</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-bash\"   nocopy=\"false\"><code><span class=\"token function\">git</span> clone git://github.com/semanticlink/todo-rest-api\n</code></pre>\n      </div>\n</Instruction>\n<p>All dependencies are documented <a href=\".../Readme.md\">in this Readme</a> and include:</p>\n</Instruction>\n<ul>\n<li>Docker</li>\n<li>Rider (api)</li>\n<li>WebStorm (client)</li>\n<li><a href=\"https://www.microsoft.com/net/download\">.NET Core 2.1 SDK v.2.1.401</a></li>\n<li><a href=\"https://nodejs.org/en/\">nodejs</a> (>= 10.0.0)</li>\n<li><a href=\"https://yarnpkg.com/latest.msi\">yarn</a> (1.6.0 or above)</li>\n</ul>\n<h4>Start applications</h4>\n<ol>\n<li>Start the database.</li>\n</ol>\n<Instruction>\n<p>Start the database in a docker container</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-bash\"   nocopy=\"false\"><code>docker run -p 8000:8000 -it --rm instructure/dynamo-local-admin`\n</code></pre>\n      </div>\n</Instruction>\n<p>You can view this in a browser on <code>http://localhost:8000</code></p>\n<ol start=\"2\">\n<li>Build and run the project with the following environment variables.</li>\n</ol>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-none\"   nocopy=\"undefined\"><code>    ASPNETCORE_ENVIRONMENT: Development\n    ASPNETCORE_URLS: http://localhost:5000</code></pre>\n      </div>\n<Instruction>\n<p>Restore the package dependencies with <code>dotnet</code> commandline (or through the IDE)</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-bash\"   nocopy=\"false\"><code><span class=\"token function\">cd</span> api\ndotnet restore\n</code></pre>\n      </div>\n</Instruction>\n<Instruction>\n<p>Run the <code>Api</code> project through the IDE (eg Rider)</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-none\"   nocopy=\"undefined\"><code>Exec Path: Api/bin/Debug/netcoreapp2.1/Api.dll\nWorking Directory: ./api/Api\nEnvironment Variables: ASPNETCORE_ENVIRONMENT=Development;ASPNETCORE_URLS=http://localhost:5000</code></pre>\n      </div>\n</Instruction>\n<ol start=\"3\">\n<li>Build and run the <code>client</code> commandline with <code>yarn</code> (or through the IDE, eg WebStorm).</li>\n</ol>\n<Instruction>\n<p>Run the client</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-none\"   nocopy=\"undefined\"><code>cd client\nyarn install\nyarn dev</code></pre>\n      </div>\n</Instruction>\n<p>It will open a browser in <code>http://localhost:8080</code></p>\n<p>At some stage, you will need to authenticate. The credentials are at the top of the page.</p>",
			"fields": {
				"slug": "/vue-todo-app/1-getting-started/"
			},
			"excerpt": "Before learning about how to write a todo client across the hypermedia API, let’s start by running the existing one. The live demo: api.todo...",
			"frontmatter": {
				"title": "Getting started",
				"videoId": null,
				"videoAuthor": null,
				"parent": "/Users/todd/src/howtohypermedia/content/frontend/vue-todo-app/1-getting-started.md absPath of file",
				"question": null,
				"answers": null,
				"correctAnswer": null,
				"description": "Learn how to build a todo client to use the hypermedia API ",
				"pageTitle": "Building and running the todo client and API"
			}
		},
		"mds": {
			"edges": [
				{
					"node": {
						"frontmatter": {
							"title": "Get started with your favorite technology",
							"description": null
						},
						"fields": {
							"slug": "/choose/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Update Collection Resource",
							"description": "Learn the code mechanics of a edit forms on a collection resource that uses different mime-types"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/11-update-collection/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "It was great having you!",
							"description": null
						},
						"fields": {
							"slug": "/success/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Update Singleton Resource",
							"description": "Learn the code mechanics of a edit forms on a singleton resource"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/10-update-singleton/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a hypermedia API that works within the constraints of REST"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to build a hypermedia API "
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "",
							"description": null
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/2-modelling-representations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Modelling Domain",
							"description": "Learn how to diagram the API textually and get also get visual output"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/3-modelling-domain-link-relations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Constructing Representations",
							"description": "Learn the code mechanics of request/response of representation in an MVC framework with the root API representation containing links and a version"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/4-constructing-representations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Constructing Collections",
							"description": "Learn the code mechanics of a singleton resource with the user resource"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/6-constructing-collection/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Constructing Searchable Resources",
							"description": "Learn the code mechanics of a search forms on a collection"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/8-constructing-search-resources/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Constructing Singletons",
							"description": "Learn the code mechanics of a singleton resource with the user resource"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/5-constructing-singleton/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Create Resource",
							"description": "Learn the code mechanics of a create forms on a collection"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/9-create-resource/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Constructing Virtual Resource",
							"description": "Learn the code mechanics of a virtual resource with the user resource"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/7-constructing-viritual/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a todo app and admin functions over the top of a hypermedia API"
						},
						"fields": {
							"slug": "/vue-todo-app/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Client-side URLs and routing",
							"description": "Design your application around the holding and reconstructing client state through the URI in the browser location requires matching client views and the data it requires"
						},
						"fields": {
							"slug": "/vue-todo-app/2-client-side-urls-and-routing/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting started",
							"description": "Learn how to build a todo client to use the hypermedia API "
						},
						"fields": {
							"slug": "/vue-todo-app/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Client-side application cache",
							"description": "Client need to have one copy of representations in the application cache"
						},
						"fields": {
							"slug": "/vue-todo-app/3-application-cache/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Updates and deletes",
							"description": "The application cache also deals with the updates and deletion of resources"
						},
						"fields": {
							"slug": "/vue-todo-app/4-updates-and-deletes/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "On-demand Authentication",
							"description": "Be able to create and renew authentication tokens when the server requests valid authentication tokens"
						},
						"fields": {
							"slug": "/vue-todo-app/5-on-demand-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "Learn how to build a todo app over the top of a hypermedia API"
						},
						"fields": {
							"slug": "/vue-todo-app/7-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to build a general purpose client to browse over the API "
						},
						"fields": {
							"slug": "/vue-api-browser/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Cloning Resources",
							"description": "Forms in hypermedia make cloning of trees straightforward and we can leverage that with drag and drop functionality alongside the client-side application cache"
						},
						"fields": {
							"slug": "/vue-todo-app/6-cloning-resources/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "HTML representation",
							"description": "Learn what and why to build HTML representation of data with code on demand"
						},
						"fields": {
							"slug": "/vue-api-browser/2-build-html-representation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a general purpose client to browse over the API "
						},
						"fields": {
							"slug": "/vue-api-browser/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Generate HTML",
							"description": "Learn how to respond as HTML in ASP.NET Core"
						},
						"fields": {
							"slug": "/vue-api-browser/3-build-html-content-negotiation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Register text/html",
							"description": "Learn how to respond to HTML content negotiation in ASP.NET Core"
						},
						"fields": {
							"slug": "/vue-api-browser/4-register-html-content-negotiation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "GET application/json",
							"description": "Learn how to request JSON from the client"
						},
						"fields": {
							"slug": "/vue-api-browser/5-request-json/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "Learn how to user hypermedia as engine to navigate an API and make changes"
						},
						"fields": {
							"slug": "/vue-api-browser/10-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Displaying with interaction",
							"description": "Learn how to process JSON to make delete, create and update"
						},
						"fields": {
							"slug": "/vue-api-browser/6-displaying-with-interaction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Displaying forms",
							"description": "Learn how to process form values for create and edit forms"
						},
						"fields": {
							"slug": "/vue-api-browser/8-displaying-form-values/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Deleting a resource",
							"description": "Learn how to process JSON to try and delete a resource"
						},
						"fields": {
							"slug": "/vue-api-browser/7-try-delete-representation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn all about hypermedia and why a REST-style of architecture is simple and subtle. It's not really for the lazy or those who like to be clever."
						},
						"fields": {
							"slug": "/basics/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Minimally layered design",
							"description": "Learn why hypermedia is a thin layer across persistence that should guide us through the business problem."
						},
						"fields": {
							"slug": "/basics/1-minimally-layered-design/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Submitting forms",
							"description": "Learn how to process creates (POST) and updates (PUT) on a resource"
						},
						"fields": {
							"slug": "/vue-api-browser/9-submitting-forms/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Big Picture (Trends)",
							"description": "Learn that distributed applications have trended towards data and business logic being processed at the client edge"
						},
						"fields": {
							"slug": "/basics/3-big-picture/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Hypermedia for the dedicated",
							"description": "Learn some techniques that will ease the server and client development"
						},
						"fields": {
							"slug": "/basics/4-for-the-dedicated/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Navigating a hypermedia API",
							"description": "Learn what a hypermedia looks like to be able to explore a domain."
						},
						"fields": {
							"slug": "/basics/2-navigating-api/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Multiple clients",
							"description": "Learn that most APIs should have multiple types of clients."
						},
						"fields": {
							"slug": "/advanced/0-multiple-clients/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "API Modelling",
							"description": "Learn about how collections and singletons are modelled in hypermedia"
						},
						"fields": {
							"slug": "/advanced/1-api-modelling/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Forms Modelling",
							"description": "Links and Forms are used to update resources and controlled by the server that the client then uses"
						},
						"fields": {
							"slug": "/advanced/2-forms-modelling/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Common Questions",
							"description": "Answer common questions about these tutorials"
						},
						"fields": {
							"slug": "/advanced/4-common-questions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Todo Domain",
							"description": "Learn about domain of the API"
						},
						"fields": {
							"slug": "/advanced/3-todo-domain/"
						}
					}
				}
			]
		}
	},
	"pathContext": {
		"slug": "/vue-todo-app/1-getting-started/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/vue-todo-app-1-getting-started.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/vue-todo-app-1-getting-started.json
// module chunks = 9